import { Link } from 'react-router-dom'
import { Logo } from './Logo'
import { CONTACT_EMAIL } from '../lib/site'
import s from './SiteFooter.module.css'

export function SiteFooter() {
  return (
    <footer className={s.footer}>
      <div>
        <div className={s.lockup}>
          <Logo small asLink />
        </div>
        <div className={s.copyright}>
          <span className={s.wide}>© 2026 Tiny Boss. Made by two very tired people.</span>
          <span className={s.narrow}>© 2026 Tiny Boss</span>
        </div>
      </div>

      <nav className={s.links} aria-label="Footer">
        <Link className={s.link} to="/privacy">
          Privacy
        </Link>
        <Link className={s.link} to="/terms">
          Terms
        </Link>
        <a className={s.link} href={`mailto:${CONTACT_EMAIL}`}>
          <span className={s.wide}>{CONTACT_EMAIL}</span>
          <span className={s.narrow}>Contact</span>
        </a>
      </nav>
    </footer>
  )
}
